import React,{Component} from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from "redux";
import Switch from 'react-switchery';
import moment from 'moment'
import axios from 'axios'
import querystring from 'querystring'
import { WithContext as ReactTags } from 'react-tag-input';
import "../../../template/custom/react-tags.css";

import *as config from '../../../config'
import * as dashboardOffersActions from "../../../actions/dashboardOffersActions";
import EditableText from '../../Shared/EditableText'
import Spinner from "../../Shared/Spinner";
import AdminMenu from "../../Shared/SideBar/AdminMenu";

class Offers extends Component{
    constructor(props){
        super(props)
        
        let {id} = this.props.match.params;
        let {dashboardOffersActions} = this.props;
        dashboardOffersActions.Get(id);
    }    
    render(){
        let{offers} = this.props;              
        return(
            <div>                
                <div className="table-wrapp">
                    <div className="datatable-header">
                            {
                                offers.data.length > 0 ?
                                    offers.data.map((item,index) => {
                                        let key = index
                                        return(
                                            <p>{item.offer}</p>
                                        )
                                    })
                                    : offers.set ?
                                    <p>
                                        Нет данных                                        
                                    </p>
                                    :null
                            }
                    </div>                    
                </div>
            </div>                
        );
    }
}

function mapStateToProps(state) {
    return {
        offers: state.offers
    }
}

function mapDispatchToProps(dispath) {
    return {
        dashboardOffersActions: bindActionCreators(dashboardOffersActions, dispath),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Offers);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Offers/index.jsx